module.exports = __webpack_public_path__ + "img/qiwi.307e0435.svg";